import { StripeConnectReturn } from '../components/StripeAccountCard';
import { usePermissions, useSession } from '../session';

/**
 * Where Stripe sends the browser back after an existing account is connected
 * with OAuth (D-393). One address for both doors, because it is registered
 * in STGD's Connect settings: STGD staff complete it through the STGD door,
 * anybody else through Settings → Payments. The API ties the `state` to the
 * person who started it either way.
 */
export default function StripeConnectReturnPage() {
  const session = useSession();
  const can = usePermissions();
  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold text-ink-900">Connecting a Stripe account</h1>
      {/* The door depends on who this is, so nothing is sent until the session says. */}
      {session.data ? <StripeConnectReturn door={can('platform.stripe_account.manage') ? 'platform' : 'settings'} /> : <p className="text-sm text-ink-600">Checking your session…</p>}
    </div>
  );
}
